require('../Sass/app.scss');

// ToDo: Move these imports where they are actually used, webpack will collect and bundle them automatically
require('select2/dist/js/select2.full');
require('jquery-ui-dist/jquery-ui');
require('moment');

// Hyphenopoly config
global.Hyphenopoly = {
	require: {
    	"la": "honorificabilitudinitas",
        "de": "Silbentrennungsalgorithmus",
        "de-de": "Silbentrennungsalgorithmus",
        "en-us": "Supercalifragilisticexpialidocious"
	},
	setup: {
		selectors: {
			".blb-container": {}
		}
	}
};

$(document).ready(() => {
	let App = require('./Core/App').default;

    document.blbweb = new App('/typo3conf/ext/blbweb');
});